import t from "@ext/localization/locale/translate";
import type { ItemLink } from "@ext/navigation/NavigationLinks";
import { ConfirmPopover } from "@ui-kit/ConfirmPopover";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import type { ReactElement } from "react";
import { useDeleteItem } from "./DeleteArticleTrigger";

type DeleteItemButtonProps = {
	itemLink: ItemLink;
	/** The button, drawn like its neighbours; its name, tooltip and click come from here. */
	children: ReactElement;
	onConfirmOpenChange?: (open: boolean) => void;
};

export const DeleteItemButton = ({ itemLink, children, onConfirmOpenChange }: DeleteItemButtonProps) => {
	const { confirmation, remove } = useDeleteItem(itemLink);
	const options = confirmation();

	const trigger = (
		<TooltipTrigger aria-label={t("delete")} asChild onClick={options ? undefined : () => void remove()}>
			{children}
		</TooltipTrigger>
	);

	return (
		<Tooltip>
			{options ? (
				<ConfirmPopover {...options} onConfirm={remove} onOpenChange={onConfirmOpenChange}>
					{trigger}
				</ConfirmPopover>
			) : (
				trigger
			)}
			<TooltipContent focus="high">{t("delete")}</TooltipContent>
		</Tooltip>
	);
};
